import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { countNewIdeas } from '../lib/capturedIdeas';

// Aantal 'nieuw' captured_ideas voor de ingelogde gebruiker. Ververst bij
// route-wissel zodat toevoegen/verwijderen/uitwerken de badge bijwerkt.
export function useOpenIdeaCount(): number {
  const { user } = useAuth();
  const location = useLocation();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!user?.id) { setCount(0); return; }
    countNewIdeas(user.id).then(setCount).catch(() => setCount(0));
  }, [user?.id, location.pathname]);
  return count;
}
